<div class="table-wrapper">
  <p-table
    #myTable
    [value]="comments"
    [paginator]="false"
    [lazy]="false"
    styleClass="p-datatable-striped"
    sortMode="single"
    [scrollable]="true"
    [scrollHeight]="'340px'"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="category" id="header-category">
          {{ "MULTICAST.COMMENTS.CATEGORY" | translate }}
          <p-sortIcon field="createdAt"></p-sortIcon>
          <p-columnFilter
            type="text"
            matchMode="contains"
            display="menu"
            field="category.name"
            [showOperator]="false"
            [showAddButton]="false"
          />
        </th>
        <th pSortableColumn="comment" id="header-comment">
          {{ "MULTICAST.COMMENTS.COMMENT" | translate }}
          <p-columnFilter
            type="text"
            matchMode="contains"
            display="menu"
            field="comment"
            [showOperator]="false"
            [showAddButton]="false"
          />
        </th>
        <th
          pSortableColumn="createdAt"
          class="table-date"
          id="header-createdAt"
        >
          {{ "CREATED" | translate }}
          <p-sortIcon field="createdAt"></p-sortIcon>
          <p-columnFilter
            type="date"
            matchMode="contains"
            display="menu"
            field="createdAt"
            [showOperator]="false"
            [showAddButton]="false"
          />
        </th>
        <th class="username" pSortableColumn="username" id="header-username">
          {{ "USERS.TITLE" | translate }}
          <p-sortIcon field="username"></p-sortIcon>
          <p-columnFilter
            type="text"
            matchMode="contains"
            display="menu"
            field="username"
            [showOperator]="false"
            [showAddButton]="false"
          />
        </th>
        <th id="header-file">
          {{ "MULTICAST.COMMENTS.FILE" | translate }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-comment>
      <tr>
        <td>{{ comment.category?.name }}</td>
        <td>
          <pre>{{ comment.comment }}</pre>
        </td>
        <td>{{ comment?.createdAt | date : "dd/MMM/yyyy, HH:mm" }}</td>
        <td>{{ comment?.username }}</td>
        <td>
          <div (click)="downloadFile(comment.file)" *ngIf="comment?.file" class="file-link">
            <i class="pi pi-download" style="color: blue;"></i>
            {{ comment.file | slice : 0 : 20 }}
            {{ comment.file?.length > 20 ? "..." : "" }}
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<form [formGroup]="form" class="p-fluid">
  <div class="form-row">
    <p-dropdown
      id="txtCategory"
      [options]="categories"
      [dataKey]="'id'"
      [optionLabel]="'name'"
      formControlName="category"
      placeholder="{{ 'MULTICAST.COMMENTS.SELECT_CATEGORY' | translate }}"
      [showClear]="true"
    ></p-dropdown>
    <textarea
      id="txtComment"
      class="w-full"
      pInputTextarea
      formControlName="comment"
      rows="5"
    ></textarea>
    <button
      type="button"
      pButton
      (click)="saveComment()"
      [disabled]="form.invalid"
    >
      <i class="pi pi-send"></i>
    </button>
  </div>
  <afoone-file-upload formControlName="file"></afoone-file-upload>
</form>
